import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import React, { useMemo } from "react";
import { employeeEmploymentStatusObj } from "../Constant";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";

const StatusHistoryList = ({ data }) => {
  const statusHistoryColumns = useMemo(() => {
    let data = [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "employmentStatus",
        text: "Status",
        sort: true,
        formatter: (rowContent, row) => {
          const finalStatusObj = { ...employeeEmploymentStatusObj, inActive: "InActive" };
          return finalStatusObj[row?.employmentStatus];
        },
      },
      {
        dataField: "dateOfJoining",
        text: "Date of Joining",
        sort: true,
        formatter: (rowContent, row) =>
          row?.dateOfJoining ? DDMMYYYYFormat(row?.dateOfJoining) : "",
      },
      {
        dataField: "dateOfSeparation",
        text: "Date of Separation",
        sort: true,
        formatter: (rowContent, row) =>
          row?.dateOfSeparation ? DDMMYYYYFormat(row?.dateOfSeparation) : "",
      },
      {
        dataField: "createdBy",
        text: "CreatedBy",
        sort: true,
        formatter: (rowContent, row) =>
          row?.users ? row?.users?.firstName + " " + row?.users?.lastName : "",
      },
      {
        dataField: "updatedAt",
        text: "UpdatedAt",
        sort: true,
        formatter: (rowContent, row) =>
          row?.updatedAt ? DDMMYYYYFormat(row?.updatedAt) : "",
      },
      {
        dataField: "remark",
        text: "Remark",
        sort: true,
      },
    ];
    return data;
  }, []);
  return (
    <div className="mt-2 mb-4">
      <h5>History</h5>

      <SearchBootstrapTable
        tableName={"site-history"}
        data={data?.map((obj, i) => ({ ...obj, sid: i + 1 }))}
        columns={statusHistoryColumns}
        tableDownloadFlag={false}
      />
    </div>
  );
};

export default StatusHistoryList;
